import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import AuthModal from "../../../components/AuthModal";

export const Navigation = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { currentUser, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <>
      <nav className="navbar navbar-custom">
        <div className="container">
          <div className="navbar-header">
            <a className="navbar-brand" href="/">
              Cheat Sheet AI
            </a>
          </div>
          <div className="navbar-right">
            {currentUser ? (
              <button onClick={handleLogout} className="btn-landing">
                Log Out
              </button>
            ) : (
              <button
                onClick={() => setShowAuthModal(true)}
                className="btn-landing"
              >
                Log In / Sign Up
              </button>
            )}
          </div>
        </div>
      </nav>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
      />
    </>
  );
};
